import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const StocksImage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      stocksImage: file(
        relativePath: {
          eq: "components/pages/CompanyPage/Sections/InvestSection/img/stocks.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, maxHeight: 936, quality: 75) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.stocksImage.childImageSharp.fluid} {...props} />
}

export default StocksImage
